import {Serializable} from './deserialize.service';

export class Employee implements Serializable<Employee> {
    id: number;
    name: string;
    email: string;
    taxId: string;
    deserialize(input) {
        this.id = input.id;
        this.name = input.name;
        this.email = input.email;
        this.taxId = input.taxId;
        return this;
    }
}
